import React, { FC, useCallback } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';
import { Colors, AnalyticsProps, useAnalytics } from '@inplayer-org/inplayer-ui';

// constants
import { TRACK_TYPE } from '../MultipageDropdown';

interface CircleButtonProps {
  isDisabled: boolean;
  isSelected: boolean;
}

const CircleButton = styled.button<CircleButtonProps>`
  ${({ isDisabled, isSelected, theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.25em;
    width: 2.1em;
    height: 2.1em;
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;

    ${
      isDisabled
        ? `
            cursor: not-allowed;

            ${
              isSelected
                ? `
                    background-color: #74d3f5;
                    border-color: #74d3f5;
                    color: ${Colors.white};
                  `
                : `
                    background-color: ${Colors.white};
                    color: ${theme.palette.text.disabled};
                    border-color: ${theme.palette.text.disabled};
                  `
            }
          `
        : `
            :hover {
              cursor: pointer;
            }

            ${
              isSelected
                ? `
                    background-color: ${theme.palette.primary.main};
                    color: ${Colors.white};
                    border-color: ${theme.palette.primary.main};
                  `
                : `
                    background-color: ${Colors.white};
                    color: ${theme.palette.text.light};
                    border-color: ${theme.palette.text.disabled};

                    :hover {
                      background-color: ${Colors.white};
                      color: ${theme.palette.primary.main};
                      border-color: ${theme.palette.primary.main};
                    }
                  `
            }
          `
    }
  `}
`;

interface OwnProps {
  title?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  page: number;
  onClick: (pageNumber: number) => void;
}

type Props = OwnProps & AnalyticsProps;

const PageButton: FC<Props> = ({
  tag,
  title = '',
  isSelected = false,
  isDisabled = false,
  page,
  onClick,
  children,
}) => {
  const { track } = useAnalytics();

  const clickHandler = useCallback(() => {
    if (tag) {
      track({ event: 'click', type: TRACK_TYPE, tag });
    }

    onClick(page);
  }, [page, onClick, tag, track]);

  return (
    <CircleButton
      type="button"
      isDisabled={isDisabled}
      isSelected={isSelected}
      title={title}
      onClick={isDisabled ? noop : clickHandler}
    >
      {children}
    </CircleButton>
  );
};

export default PageButton;
